// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__jY-mg","right":"Footer_right__2t3yI","buttons":"Footer_buttons__1gWLG"};